import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import Head from '../../Components/Common/Head';
import IndiviualImage from '../../Components/PropertyDetails/IndiviualImage';
import PropertyROICalculator from '../../Components/PropertyDetails/PropertyROICalculator';
import BoxAmenities from '../../Components/PropertyDetails/BoxAmenities';
import BoxPropertyDetail from '../../Components/PropertyDetails/BoxPropertyDetail';
import SinglePropertymap from '../../Components/PropertyDetails/SinglePropertymap';
import InvestBenefits from "../../Components/PropertyDetails/InvestBenefits";
import FormContactAgent from '../../Components/PropertyDetails/FormContactAgent';
import FractionalDetails from '../../Components/PropertyDetails/FractionalDetails';
import WgProperty from "../../Components/PropertyDetails/WgProperty";
import TermsConditions from "../../Components/PropertyDetails/TermsConditions"
import InvestmentPrice from "../../Components/PropertyDetails/InvestmentPrice"
import SinglePropertyNearby from '../../Components/PropertyDetails/SinglePropertyNearby'
import ErrorMessage from '../../Components/Common/ErrorMessage';


const PropertyDetails = () => {
  const { property_id } = useParams(); 
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("property_id", property_id);
  
  useEffect(() => {
    setLoading(true);  
    if (!property_id) {
      setError("Missing property_id");
      setLoading(false);
      return;
    }
  
    fetch (`${process.env.REACT_APP_GET_PROPERTIES_DETAIL}?id=${property_id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch property data');
        }
        return response.json();  
      })
      .then((data) => {
        console.log("response", data);
  
        if (data.error) {
          throw new Error(data.error);  
        }
  
        setPropertyData(data);  
      })
      .catch((error) => {
        setError(error.message);  
      })
      .finally(() => {
        setLoading(false);       });
  }, [property_id]);
  


  const GallerySkeleton = () => {
    return (
      <div className="wrapper-section-gallery gallery-skeleton">
        <div className="left-gallery-skeleton">
          <div className="image-skeleton"></div>
        </div>
        <div className="right-gallery-skeleton">
          <div className="right-gallery-section-1-skeleton">
            <div className="image-skeleton"></div>
          </div>
          <div className="right-gallery-section-2-skeleton">
            <div className="right-gallery-image-skeleton">
              <div className="image-skeleton"></div>
            </div>
            <div className="right-gallery-image-skeleton">
              <div className="image-skeleton"></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <div><GallerySkeleton /></div>;
  }

  if (error) {
    return <div><ErrorMessage message="Property Not Found" /></div>;
  }

  if (!propertyData) {
    return  {property_id};
  }

  const { 
    property_name, 
    property_address, 
    property_images, 
    amenities, 
    direction, 
    about, 
    investment_benefits, 
    roi_calculator, 
    fraction_details, 
    property_details,
    terms_conditions,
    investment_price,
    what_nearby,
    fraction_details_summary
  } = propertyData;

  return (
    <div>
      {/* {/ <Head /> /} */}
      <IndiviualImage data={property_images} />
      <div className="section-property-detail">
        <div className="tf-containers">
          <div className="row">
            <div className="col-xl-8 col-lg-7">
              <WgProperty
                property_details={property_details}
                property_name={property_name || 'No name available'}
                property_address={property_address || 'No address available'}
                fraction_details={fraction_details_summary}
              />
              <FractionalDetails fraction_details={fraction_details} />
              <PropertyROICalculator roi_calculator={roi_calculator} />
              <BoxPropertyDetail about={about} />
              <BoxAmenities amenities={amenities} />
               <SinglePropertyNearby what_nearby={what_nearby}/>
              <SinglePropertymap direction={direction} />
              <InvestBenefits investment_benefits={investment_benefits} />
              <TermsConditions terms_conditions={terms_conditions}/>
              <InvestmentPrice investment_price={investment_price} />
            </div>
            <div className="col-xl-4 col-lg-5">
              <div className="tf-sidebar sticky-sidebar">
                <FormContactAgent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetails;